import { render, staticRenderFns } from "./ArticleListPage.vue?vue&type=template&id=fab97248&scoped=true"
import script from "./ArticleListPage.vue?vue&type=script&lang=js"
export * from "./ArticleListPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleListPage.vue?vue&type=style&index=0&id=fab97248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab97248",
  null
  
)

export default component.exports